import { Component, ViewChild, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { ServiceType } from 'src/app/public/common/constants/common-basic-data';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgClass } from '@angular/common';
import { DealerType, BusinessType, UserCivility, DealerStatus } from 'src/app/public/account/constants/dealer-basic-data';


@Component({
    selector: 'app-dynamic-table',
    templateUrl: './dynamic-table.component.html',
    styleUrl: './dynamic-table.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatIconModule, MatTableModule, MatSelectModule, MatPaginator, DragDropModule, NgClass]
})

export class DynamicTableComponent implements OnInit, AfterViewInit {

  dataSource1 = new MatTableDataSource([
    { id: 1, name: 'John Doe', age: 25, email: 'john@example.com' },
    { id: 2, name: 'Jane Smith', age: 30, email: 'jane@example.com' },
    { id: 3, name: 'Alice Brown', age: 22, email: 'alice@example.com' },
  ]);

  enumOptions1: { [key: string]: string[] } = {
    dealerType: Object.values(DealerType),
    businessType: Object.values(BusinessType),
    civility: Object.values(UserCivility),
    status: Object.values(DealerStatus),
    servicesProvided: Object.values(ServiceType)
  };

  enumOptions: { [key: string]: { key: string, label: string }[] } = {
    dealerType: Object.entries(DealerType).map(([key, label]) => ({ key, label })),
    businessType: Object.entries(BusinessType).map(([key, label]) => ({ key, label })),
    civility: Object.entries(UserCivility).map(([key, label]) => ({ key, label })),
    status: Object.entries(DealerStatus).map(([key, label]) => ({ key, label })),
    servicesProvided: Object.entries(ServiceType).map(([key, label]) => ({ key, label }))
  };

  @Input() items: any[] = []
  dataSource = new MatTableDataSource(this.items)

  @Output() updatedItemEmitter = new EventEmitter<any>();
  @Output() deletedItemEmitter = new EventEmitter<any>();

  displayedColumns: string[] = [];
  allColumns: string[] = [];
  editingCell: { rowIndex: number; column: string } | null = null;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.items)
    if (this.dataSource.data.length > 0) {
      this.allColumns = Object.keys(this.dataSource.data[0]); // Extract keys dynamically
      //this.displayedColumns = [...this.allColumns]; // Show all columns initially
      //this.displayedColumns = [];
      this.displayedColumns = ['actions', ...this.allColumns.slice(0, 5)];
    }
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource = new MatTableDataSource(this.items)
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  toggleColumn(column: string) {
    if (this.displayedColumns.includes(column)) {
      this.displayedColumns = this.displayedColumns.filter(col => col !== column);
    } else {
      this.displayedColumns.push(column);
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.displayedColumns, event.previousIndex, event.currentIndex);
  }

  startEditing1(rowIndex: number, column: string) {
    this.editingCell = { rowIndex, column };
  }

  startEditing2(rowIndex: number) {
    this.editingCell = { rowIndex, column: '' };
  }

  startEditing(rowIndex: number, column?: string) {
    let col: string = column !== null ? column! : ''
    this.editingCell = { rowIndex, column: col };
  }

  stopEditing() {
    this.editingCell = null;
  }

  updateRow(index: number){
    console.log(this.dataSource.data[index])
  }

  deleteRow(index: number) {
    this.dataSource.data.splice(index, 1);
    this.dataSource._updateChangeSubscription(); // Update table
  }

  sendUpdatedItem(item: any) {
    this.updatedItemEmitter.emit(item); 
  }

  sendDeletedItem(item: any) {
    this.deletedItemEmitter.emit(item); 
  }

  getType(item: any){
    return typeof(item)
  }
}